module.exports = __webpack_public_path__ + "static/img/img_q.a596f9b7.png";